/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { EvidenceExportGipReportMutationRequest, EvidenceExportGipReportMutationResponse, EvidenceExportGipReportPathParams, EvidenceExportGipReport400, EvidenceExportGipReport404 } from "../models/EvidenceExportGipReport";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { evidenceExportGipReport } from "../axios/evidenceExportGipReport";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const evidenceExportGipReportMutationKey = () => ["audit-reports-api", { url: '/reports/gip/report/:id/evidence-export' }] as const

export type EvidenceExportGipReportMutationKey = ReturnType<typeof evidenceExportGipReportMutationKey>

export function evidenceExportGipReportMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EvidenceExportGipReportMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = evidenceExportGipReportMutationKey()
        return mutationOptions<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, {id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return evidenceExportGipReport(id, data, config)
          },
        })

}

/**
 * @summary Start evidence export
 * {@link /reports/gip/report/:id/evidence-export}
 */
export function useEvidenceExportGipReport<TContext>(options: 
{
  mutation?: UseMutationOptions<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, {id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EvidenceExportGipReportMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? evidenceExportGipReportMutationKey()

          const baseOptions = evidenceExportGipReportMutationOptions(config) as UseMutationOptions<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, {id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest}, TContext>
          

          return useMutation<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, {id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EvidenceExportGipReportMutationResponse, ResponseErrorConfig<EvidenceExportGipReport400 | EvidenceExportGipReport404>, {id: EvidenceExportGipReportPathParams["id"], data: EvidenceExportGipReportMutationRequest}, TContext>
      
}